import React, {useState} from "react";
import Chart from "react-apexcharts";

const VisitorInsight = () => {

    const chartOptions = {
        chart: {
          id: 'visitor-insights',
          toolbar: {
            show: false, // hide the toolbar if unnecessary
          },
        },
        colors: ['#800080', '#FF6347'], // Colors for the lines: purple and red
        stroke: {
          curve: 'smooth',
          width: 3, // Thicker lines for better visibility
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
          tickAmount: 12, // Number of ticks along the x-axis
        },
        yaxis: {
          title: {
            text: '',
          },
          min: 0,
          max: 400, // Set maximum for y-axis to align with the chart
          tickAmount: 4,
        },
        markers: {
          size: [0, 0], // Size of the markers, 0 for 'Loyal Customers' and 8 for 'New Customers'
          colors: ['#FF6347'],
          strokeColors: ['#fff'], // Marker border color
          strokeWidth: 2,
          hover: {
            size: 4, // Hover effect on the marker
          },
        },
        legend: {
          position: 'bottom',
          markers: {
            fillColors: ['#800080', '#FF6347'],
          },
        },
        annotations: {
        //   xaxis: [
        //     {
        //       x: 'Jul',
        //       borderColor: '#FF6347',
        //       label: {
        //         borderColor: '#FF6347',
        //         style: {
        //           color: '#fff',
        //           background: '#FF6347',
        //         },
        //         text: 'July Marker',
        //       },
        //     },
        //   ],
        },
      };


    const chartSeries = [
        {
          name: 'Basavraj P',
          data: [300, 260, 230, 200, 180, 160, 150, 180, 230, 280, 300, 320],
        },
        {
          name: 'Manjunath D',
          data: [200, 180, 150, 160, 180, 210, 240, 250, 260, 270, 240, 200],
        },
      ];
    return (
        <Chart options={chartOptions} series={chartSeries} type="line" height="200" />
    )
}

export default VisitorInsight;